<template>
    <PageView>
        <a-card title="列表">
            <a-table :loading="loading" :columns="columns" :dataSource="data"
                :pagination="{ total, pageSize, showSizeChanger, current }" @change="changePagination" bordered
                :scroll="{ x: true }">
            </a-table>
        </a-card>
        <a-modal title="修改配置项" :visible="saveContent" centered :closable="false" :maskClosable="false" width="1000px">
            <div v-if="type == 3">
                <p>内容:</p>
                <div class="editCon">
                    <editor id="tinymce" v-model="content" :init="init"></editor>
                </div>
            </div>
            <div v-if="type == 2">
                <a-row :gutter="10" class="inputGroup" style="margin-bottom: 20px" type="flex" justify="space-around"
                    align="middle">
                    <a-col :xs="24" :md="16" :lg="16" :xl="10">
                        <div class="imgContaienr">
                            <div class="con">
                                <img v-if="pic !== ``" :src="pic" />
                                <a v-else class="placeText">请选择图片</a>
                            </div>
                        </div>
                    </a-col>
                    <a-col :xs="24" :md="8" :lg="8" :xl="14">
                        <div class="btnCon">
                            <input @change="handleChange($event, 2)" type="file" accept="image/*" />
                            <a-button-group>
                                <a-button type="primary">选择图片</a-button>
                            </a-button-group>
                        </div>
                    </a-col>
                </a-row>
            </div>
            <div v-if="type == 4">
                <a-row :gutter="10" class="inputGroup" style="margin-bottom: 20px" type="flex" justify="space-around"
                    align="middle">
                    <a-col :xs="24" :md="16" :lg="16" :xl="10">
                        <div class="imgContaienr">
                            <div class="con">
                                <span v-if="pdf" style="width: 200px;">{{ pdf }}</span>
                                <a v-else class="placeText">请选择文件</a>
                            </div>
                        </div>
                    </a-col>
                    <a-col :xs="24" :md="8" :lg="8" :xl="14">
                        <div class="btnCon">
                            <input @change="handleChange($event, 4)" type="file" accept="application/pdf" />
                            <a-button-group>
                                <a-button type="primary">选择文件</a-button>
                            </a-button-group>
                        </div>
                    </a-col>
                </a-row>
            </div>
            <a-input v-model="content" placeholder="请输入内容" v-if="type == 1" />
            <template slot="footer">
                <a-button-group>
                    <a-button type="primary" :loading="btnloading" @click="sub()">确定</a-button>
                    <a-button type="default" @click="saveContent = false">关闭</a-button>
                </a-button-group>
            </template>
        </a-modal>
        <a-modal title="查看详情" :visible="visible" centered :closable="false" :maskClosable="false" width="1000px">
            <div v-html="viewImg.value"></div>
            <template slot="footer">
                <a-button-group>
                    <a-button type="primary" :loading="btnloading" @click="visible = false">确定</a-button>
                    <a-button type="default" @click="visible = false">关闭</a-button>
                </a-button-group>
            </template>
        </a-modal>
    </PageView>
</template>

<script>
//  // type 类型 1输入框 2图片 3富文本
import { clearData } from '../../api/login'
import Config from '../../api/Config.js'
import Home from '../../api/Home.js'
import editor from '@tinymce/tinymce-vue'
import tinymce from 'tinymce/tinymce'
import 'tinymce/themes/silver'
import 'tinymce/plugins/image' // 插入上传图片插件
import 'tinymce/plugins/media' // 插入视频插件
import 'tinymce/plugins/code'
import 'tinymce/plugins/link'
import '../../../public/tinymce/axupimgs'
export default {
    name: 'index',
    components: {
        editor
    },
    data() {
        return {
            form: this.$form.createForm(this),
            loading: true,
            visible: false,
            viewImg: {},
            type: 1,
            pdf: '',
            labelCol: {
                xs: { span: 24 },
                sm: { span: 12 }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 12 }
            },
            inputArray: [],
            pageSize: 10,
            current: 1,
            columns: [
                {
                    title: '配置项名称',
                    dataIndex: 'name',
                    width: 300,
                    customRender: v => {
                        return v || '空'
                    }
                },
                {
                    title: '内容',
                    customRender: v => {
                        return v.type == 3 ? (
                            <a
                                onClick={() => {
                                    this.visible = true
                                    this.viewImg = v
                                }}
                            >
                                查看详情
                            </a>
                        ) : v.type == 2 ? (
                            <img style="display:block;height:40px" src={v.value} />
                        ) : (
                            v.value
                        )
                    }
                },
                {
                    title: '操作',
                    key: 'action',
                    fixed: 'right',
                    width: 110,
                    customRender: v => {
                        return (
                            <a-dropdown>
                                <a-menu slot="overlay">
                                    <a-menu-item
                                        onClick={() => {
                                            this.type = v.type
                                            this.getSave(v)
                                        }}
                                    >
                                        修改
                                    </a-menu-item>
                                </a-menu>
                                <a-button>
                                    操作 <a-icon type="down" />
                                </a-button>
                            </a-dropdown>
                        )
                    }
                }
            ],
            init: {
                language_url: `https://speciaapi.guobaotegong.com/tinymce/langs/zh_CN.js`, //语言包的路径
                language: 'zh_CN', //语言
                skin_url: `https://speciaapi.guobaotegong.com/tinymce/skins/ui/oxide`, //skin路径
                height: 500, //编辑器高度
                branding: false, //是否禁用“Powered by TinyMCE”
                menubar: false, //顶部菜单栏显示
                plugins: 'image axupimgs media',
                // plugins: 'axupimgs media',
                convert_urls: false,
                images_upload_handler: (blobInfo, success, failure) => {
                    this.handleImgUpload(blobInfo, success, failure)
                },
                toolbar:
                     'axupimgs | undo redo |  formatselect | bold italic forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | lists image media table | removeformat'
                
            },
            showSizeChanger: true,
            data: [],
            content: '',
            saveContent: false,
            btnloading: false,
            id: '',
            pic: '',
            total: 10
        }
    },
    activated() {
        this.getConfig()
    },
    methods: {
        handleImgUpload(blobInfo, success, failure) {
            let file = blobInfo.file
            let reader = new FileReader()
            reader.onload = () => {
                Home.upload({ img: reader.result }).then(res => {
                    this.content += `<img src=${res.result} style="width:100%;height:100%"/>`
                    success('')
                })
                reader.onload = null
            }
            reader.readAsDataURL(file)
        },
        handleChange(e, type) {
            let file = e.target.files[0]
            let reader = new FileReader()

            reader.onload = () => {
                if (type === 4) {
                    let img = new FormData()
                    img.append('img', file)
                    Home.upload_video(img).then(res => {
                        this.pdf = res.result
                    })
                    return
                }
                Home.upload({ img: reader.result }).then(res => {
                    if (type === 2) {
                        this.pic = res.result
                    } else if (type === 3) {
                        this.content += `<img src=${res.result} style="width:100%;height:100%"/>`
                    }
                })
                reader.onload = null
            }
            reader.readAsDataURL(file)
        },
        getSave(data) {
            this.saveContent = true
            this.content = data.value ? data.value : ''
            this.id = data.id
        },
        changePagination(pagination) {
            Object.keys(pagination).forEach(val => {
                this[val] = pagination[val]
            })
            this.getConfig()
        },
        getConfig() {
            this.loading = true
            Config.config_list({
                page: this.current,
                num: this.pageSize
            }).then(res => {
                this.data = res.result.map((value, key) => {
                    return { ...value, key }
                })
                this.total = parseInt(res.count)
                this.loading = false
            })
        },
        sub() {
            this.form.validateFields((err, values) => {
                if (!err) {
                    this.loading = true
                    if (this.type == 1) {
                        Config.save_config({
                            id: this.id,
                            value: this.content
                        })
                            .then(res => {
                                this.loading = false
                                this.saveContent = false
                                this.getConfig()
                            })
                            .catch(res => {
                                this.getConfig()
                            })
                    } else if (this.type == 2) {
                        Config.save_config({
                            id: this.id,
                            value: this.pic
                        })
                            .then(res => {
                                this.loading = false
                                this.saveContent = false
                                this.getConfig()
                            })
                            .catch(res => {
                                this.getConfig()
                            })
                    } else if (this.type == 3) {
                        Config.save_config({
                            id: this.id,
                            value: this.content
                        })
                            .then(res => {
                                this.loading = false
                                this.saveContent = false
                                this.getConfig()
                            })
                            .catch(res => {
                                this.getConfig()
                            })
                    } else if (this.type == 4) {
                        Config.save_config({
                            id: this.id,
                            value: this.pdf
                        })
                            .then(res => {
                                this.loading = false
                                this.saveContent = false
                                this.getConfig()
                            })
                            .catch(res => {
                                this.getConfig()
                            })
                    }
                }
            })
        },
        clearData() {
            clearData().then(() => {
                this.getConfig()
            })
        }
    }
}
</script>

<style scoped lang="less">
.btnCon {
    position: relative;
    overflow: hidden;
    display: inline-block;

    input {
        display: block;
        position: absolute;
        z-index: 1;
        width: 100%;
        height: 100%;
        background: red;
        opacity: 0;
    }
}

.imgContaienr {
    border-radius: 8px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    padding: 15px;

    .con {
        height: 300px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            display: block;
            max-height: 100%;
            max-width: 100%;
        }

        .placeText {
            font-size: 20px;
        }
    }
}

.editCon {
    margin-bottom: 20px;
    position: relative;

    .editCon {
        position: absolute;
        z-index: 1;
        top: 3px;
        right: 5px;
    }
}
</style>
